/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Preference } from 'src/app/model/preference';
import { PreferenceProvider } from 'src/app/providers';

@Component({
  selector: 'app-create-preference-modal',
  templateUrl: './create-preference.modal.html',
  styleUrls: ['./create-preference.modal.scss']
})

export class CreatePreferenceModal implements OnInit, OnDestroy {
  subject: Subject<Preference>;
  subscription: any;
  confirmationModal: BsModalRef;
  preference: Preference = new Preference();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private preferenceProvider: PreferenceProvider,
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onSubmit(): void {
    this.preferenceProvider.savePreference(this.preference)
      .subscribe(
        data => {
          if (data.success) {
            this.bsModalRef.hide();
            this.subject.next(Preference.parse(data.result));
            this.subject.complete();
          }
        });
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }
}
